import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-success-banner',
  imports: [],
  templateUrl: './success-banner.component.html',
  styleUrl: './success-banner.component.scss'
})
export class SuccessBannerComponent {
  @Input() message: string = 'Success';
}
